<template>
    <a class="article first-article" :href="article.link" @click.prevent.stop="openArticle(article.slug)">
        <figure class="article-image">
            <img :src="article.media[thumbnail].url" :alt="article.media[thumbnail].alt">
        </figure>
        <div class="article-body">
            <h2 class="article-title" v-html="article.title"></h2>
            <p class="article-content" v-html="article.description"></p>
            <footer class="article-info">
                <span>{{ article.formatted_date }}</span>
                <span>
                    <tags :categories="article.categories || []"></tags>
                </span>
            </footer>
        </div>
    </a>
</template>

<script>
	import router from "../article/router";
    import Tags from "../article/tags.vue";
    export default {
    	components: {
    	    Tags
        },
    	props: [
    		"article"
        ],
        data () {
    		return {
    			thumbnail: "large"
            }
        },
		methods: {
			openArticle (slug) {
				router.push({ path: `/article/${slug}`})
			}
		}
    }
</script>

<style lang="scss" scoped>
    @import "article";

    .first-article {
        flex-direction: row;
        margin-bottom: 1rem;
    }

    .first-article .article-body {
        flex: 1;
    }

    .first-article .article-body h2 {
        font-size: 1.5rem;
    }
    .first-article .article-body p {
        font-size: 1rem;
    }

    .article-image {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        overflow: hidden;
        margin: 0;
        order: 2;
        padding-top: 0;
        width: 64%;
    }

    .article-image img {
        display: block;
        object-fit: cover;
    }

    article.article.first-article > .article-body {
        font-size: 1.2rem;

    }

    @media only screen and (max-width: 40em) {
        .first-article .article-image {
            order: 1;
            flex: 100% 0;
        }

        .first-article {
            flex-wrap: wrap;
        }

        .first-article img {
            position: static;
        }

        .article-body {
            order: 2;
        }
    }

    @media screen and (min-width: 40em) {
        .first-article .article-content {
            padding-right: 0;
        }
        .first-article .article-image {
            flex: 50% 0;
        }
        .first-article .article-body h2 {
            font-size: 2rem;
        }
        .first-article .article-body p {
            font-size: 1.3rem;
        }
    }

    @media screen and (min-width: 64em) {
        .first-article .article-image {
            flex: 64% 0;
        }
        .first-article .article-body h2 {
            font-size: 2.25rem;
        }
        .first-article .article-body p {
            font-size: 1.4rem;
            padding: 1.5rem 0;
        }
        .first-article .article-content {
            line-height: 2.5rem;
        }
        .first-article .article-body {
            min-height: 500px;
        }
    }
</style>


// WEBPACK FOOTER //
// news-main.vue?08b16228